import { itx } from "../../translationItx/itx";
import { channelTypeInfo } from "../../models/ChannelType";
import guideSequence_addActorElcbTerminalStrip from "../sequences/guideSequence_addActorElcbTerminalStrip";
import guideSequence_addBackgrounPicture from "../sequences/guideSequence_addBackgrounPicture";
import guideSequence_addCabinet from "../sequences/guideSequence_addCabinet";
import guideSequence_addConsumerButton from "../sequences/guideSequence_addConsumerButton";
import guideSequence_addFloor from "../sequences/guideSequence_addFloor";
import guideSequence_addRoom from "../sequences/guideSequence_addRoom";
import guideSequence_chooseTemplate from "../sequences/guideSequence_chooseTemplate";
import guideSequence_generateKnxAdresses from "../sequences/guideSequence_generateKnxAdresses";
import sequence_connectConnectableObjWithEachOther from "../sequences/sequence_connectConnectableObjWithEachOther";
import { ToDoItem } from "../ToDoItem";
import storyLines_Framework from "./Framework";
import StoryLine_Prefixes from "./Prefixes";
import StoryLine from "./StoryLine";
import guideSequence_placeRoomsInFloor from "../sequences/guideSequence_placeRoomsInFloor";

class StoryLine_BaseIntroduction extends StoryLine {
  className = "BaseIntroduction"; // no itx

  firstItem = (): ToDoItem => {
    return this.createFloor();
  };

  description = () => {
    return itx("guideState.knxPlaning");
  };

  ///////////////////////////////////////////////////////////////////////
  // GuideState.knxPlaning
  ///////////////////////////////////////////////////////////////////////

  createFloor = (): ToDoItem => {
    return new ToDoItem({
      id: "createFloor",
      text: itx("ToDoItemLine.createFloor"),
      subSteps: undefined,
      nextStep: this.createRoom,
      done: (lastToDoElement?: ToDoItem) => {
        return state.floors.size > 0;
      },
      pattern: guideSequence_addFloor,
      prio: 1,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  createRoom = (): ToDoItem => {
    return new ToDoItem({
      id: "createRoom",
      text: itx("ToDoItemLine.createRoom"),
      subSteps: undefined,
      nextStep: this.placeRoomInFloor,
      hasToBeDoneBevoreStep: [this.createFloor],
      done: (lastToDoElement?: ToDoItem) => {
        return state.allRooms().filter((room) => !room.isFloorGeneralRoom).length > 0;
      },
      pattern: guideSequence_addRoom,
      prio: 2,
    });
  };

  ///////////////////////////////////////////////////////////////////////////
  placeRoomInFloor = (): ToDoItem => {
    return new ToDoItem({
      id: "placeRoomInFloor",
      text: itx("ToDoItemLine.placeRoomInFloor", "place Room in FloorPlan"),
      subSteps: undefined,
      nextStep: this.createConsumer,
      hasToBeDoneBevoreStep: [this.createRoom],
      done: (lastToDoElement?: ToDoItem) => {
        return state.allRooms().filter((room) => !room.isFloorGeneralRoom && !room.isVisibleInFloorPlan).length == 0;
      },
      pattern: guideSequence_placeRoomsInFloor,
      prio: 3,
    });
  };
  /////////////////////////////////////////////////////////
  chooseBackgroundPicture = (): ToDoItem => {
    return new ToDoItem({
      id: "chooseBackgroundPicture",
      text: itx("ToDoItemLine.chooseBackgroundPicture"),
      subSteps: undefined,
      prefixStep: StoryLine_Prefixes.openRoomPrefix,
      nextStep: this.createConsumer,
      hasToBeDoneBevoreStep: [this.createRoom],
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.allRooms().forEach((room) => {
          if (room.page?.backgroundImgUrl != "") {
            res = true;
          }
        });
        return res;
      },
      pattern: guideSequence_addBackgrounPicture,
      prio: 2,
    });
  };

  ////////////////////////////////////////////////////////////////////////

  createConsumer = (): ToDoItem => {
    return new ToDoItem({
      id: "createConsumer",
      text: itx("ToDoItemLine.createConsumer"), // (automatically connected with actor)",
      subSteps: undefined,
      prefixStep: StoryLine_Prefixes.openRoomPrefix,
      nextStep: this.createButton,
      hasToBeDoneBevoreStep: [this.createRoom],
      done: (lastToDoElement?: ToDoItem) => {
        return state.allConsumers().length > 0;
      },
      typeForPattern: "Consumer", // no itx
      pattern: guideSequence_addConsumerButton,
      prio: 4,
    });
  };
  ////////////////////////////////////////////////////////////////////////

  createButton = (): ToDoItem => {
    return new ToDoItem({
      id: "createButton",
      text: itx("ToDoItemLine.createButton"),
      subSteps: undefined,
      prefixStep: StoryLine_Prefixes.openRoomPrefix,
      nextStep: this.connectionConsumerWithButton,
      hasToBeDoneBevoreStep: [this.createRoom],
      done: (lastToDoElement?: ToDoItem) => {
        return state.allButtons().length > 0;
      },
      typeForPattern: "Button", // no itx
      pattern: guideSequence_addConsumerButton,
      prio: 5,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  connectionConsumerWithButton = (): ToDoItem => {
    return new ToDoItem({
      id: "connectionConsumerWithButton",
      text: itx("ToDoItemLine.connectionConsumerWithButton"),
      subSteps: undefined,
      prefixStep: StoryLine_Prefixes.openRoomPrefix,
      nextStep: this.chooseButtonTemplate,
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.allConsumers().forEach((consumer) => {
          consumer.connections.forEach((con) => {
            if (con.fromDevice?.className.includes("Button") || con.toDevice?.className.includes("Button")) {
              res = true;
            }
          });
        });
        return res;
      },
      hasToBeDoneBevoreStep: [this.createButton, this.createConsumer],
      pattern: (type, lastToDoItem) => {
        return sequence_connectConnectableObjWithEachOther("Button", "Consumer"); // no itx
      },
      prio: 6,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  connectionButtonWithConsumer = (): ToDoItem => {
    return new ToDoItem({
      id: "connectionButtonWithConsumer",
      text: itx("ToDoItemLine.connectionButtonWithConsumer"),
      subSteps: undefined,
      prefixStep: StoryLine_Prefixes.openRoomPrefix,
      //   nextStep: this.createScene,
      nextStep: this.chooseButtonTemplate,
      hasToBeDoneBevoreStep: [this.createButton, this.createConsumer],
      done: (lastToDoElement?: ToDoItem) => {
        let res = false;
        state.allButtons().forEach((button) => {
          button.buttonChannels.forEach((bc) => {
            bc.connections.forEach((con) => {
              if (con.fromDevice?.className.includes("Consumer") || con.toDevice?.className.includes("Consumer")) {
                res = true;
              }
            });
          });
        });
        return res;
      },
      pattern: (type, lastToDoItem) => {
        return sequence_connectConnectableObjWithEachOther("Consumer", "Button"); // no itx
      },
      prio: 7,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  chooseButtonTemplate = (): ToDoItem => {
    return new ToDoItem({
      id: "chooseButtonTemplate",
      text: itx("ToDoItemLine.chooseButtonTemplate"),
      subSteps: undefined,
      hasToBeDoneBevoreStep: [this.createButton],
      nextStep: this.setButtonParameter,
      done: (lastToDoElement?: ToDoItem) => {
        let res = true;
        state.allButtons().forEach((button) => {
          if (button.template == undefined) {
            res = false;
          }
        });
        return res;
      },
      typeForPattern: "Button", // no itx
      pattern: guideSequence_chooseTemplate,
      prio: 17,
    });
  };
  ////////////////////////////////////////////////////////////////////
  setButtonParameter = (): ToDoItem => {
    return new ToDoItem({
      id: "setButtonParameter",
      text: itx("ToDoItemLine.setButtonParameter"),
      subSteps: undefined,
      nextStep: this.createCabinet,
      hasToBeDoneBevoreStep: [this.chooseButtonTemplate],
      done: (lastToDoElement?: ToDoItem) => {
        return true;
      },
      prio: 18,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  createCabinet = (): ToDoItem => {
    return new ToDoItem({
      id: "createCabinet",
      text: itx("ToDoItemLine.createCabinet"),
      subSteps: undefined,
      nextStep: this.createActor,
      done: (lastToDoElement?: ToDoItem) => {
        return state.cabinets.size > 0;
      },
      pattern: guideSequence_addCabinet,
      prio: 19,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  createActor = (): ToDoItem => {
    return new ToDoItem({
      id: "createActor",
      text: itx("ToDoItemLine.createActor"),
      subSteps: undefined,
      nextStep: this.chooseActorTemplate,
      hasToBeDoneBevoreStep: [this.createCabinet],
      done: (lastToDoElement?: ToDoItem) => {
        return state.allActors().length > 0;
      },
      typeForPattern: "Actor", // no itx
      pattern: guideSequence_addActorElcbTerminalStrip,
      prio: 20,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  chooseActorTemplate = (): ToDoItem => {
    return new ToDoItem({
      id: "chooseActorTemplate",
      text: itx("ToDoItemLine.chooseActorTemplate"),
      subSteps: undefined,
      nextStep: this.setActorParameter,
      hasToBeDoneBevoreStep: [this.createActor],
      done: (lastToDoElement?: ToDoItem) => {
        let res = true;
        state.allActors().forEach((actor) => {
          if (!actor.template || channelTypeInfo(actor.channelType).isSupply) {
            res = false;
          }
        });

        return res;
      },
      typeForPattern: "Actor", // no itx
      pattern: () => {
        return guideSequence_chooseTemplate("Actor"); // no itx
      },
      prio: 21,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  setActorParameter = (): ToDoItem => {
    return new ToDoItem({
      id: "setActorParameter",
      text: itx("ToDoItemLine.setActorParameter"),
      subSteps: undefined,
      nextStep: this.generateKnxAdresses,
      hasToBeDoneBevoreStep: [this.chooseActorTemplate],
      done: (lastToDoElement?: ToDoItem) => {
        return true;
      },
      prio: 22,
    });
  };
  ////////////////////////////////////////////////////////////////////////
  generateKnxAdresses = (): ToDoItem => {
    return new ToDoItem({
      id: "generateKnxAdresses",
      text: itx("ToDoItemLine.generateKnxAdresse"),
      subSteps: undefined,
      //nextStep: this.createELCB,
      nextStep: storyLines_Framework.select_A,
      hasToBeDoneBevoreStep: [this.chooseButtonTemplate, this.chooseActorTemplate],
      done: (lastToDoElement?: ToDoItem) => {
        return state.addresses.size > 0;
      },
      pattern: guideSequence_generateKnxAdresses,
      prio: 23,
    });
  };
}

const storyLine_BaseIntroduction = new StoryLine_BaseIntroduction();
export default storyLine_BaseIntroduction;
